"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendReturnEmail = exports.updateProductStockAmount = exports.createCustomOrder = exports.editUserPrivateProfile = exports.confirmOfflineOrder = exports.createLogistics = exports.createInvoice = exports.fetchStatistics = void 0;
var Config_1 = require("../Config");
var ApiUtil_1 = require("../Utils/ApiUtil");
var Cart = __importStar(require("./Cart"));
function fetchStatistics(date_from, date_to) {
  if (date_from === void 0) {
    date_from = 0;
  }
  if (date_to === void 0) {
    date_to = 0;
  }
  return __awaiter(this, void 0, void 0, function () {
    var url;
    return __generator(this, function (_a) {
      url = Config_1.get().apiHost + "/statistics?token=" + Config_1.get().UserOutlet.getValue().token;
      return [2 /*return*/, ApiUtil_1.req(url, {
        method: 'POST',
        data: {
          date_from: date_from,
          date_to: date_to
        }
      })];
    });
  });
}
exports.fetchStatistics = fetchStatistics;
function createInvoice(order_id, staff_note) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/order/issue/invoice?token=" + Config_1.get().UserOutlet.getValue().token, {
        method: 'POST',
        data: {
          order_id: order_id,
          staff_note: staff_note
        }
      })];
    });
  });
}
exports.createInvoice = createInvoice;
function createLogistics(id) {
  return __awaiter(this, void 0, void 0, function () {
    var endpoints, url;
    return __generator(this, function (_a) {
      endpoints = {
        v1: Config_1.get().apiHost + "/order/logistics/create?token=" + Config_1.get().UserOutlet.getValue().token,
        v2: Config_1.get().apiHost + "/logistics/create?token=" + Config_1.get().UserOutlet.getValue().token
      };
      url = endpoints[Config_1.get().fastelVersion];
      return [2 /*return*/, ApiUtil_1.req(url, {
        method: 'post',
        data: {
          id: id
        }
      })];
    });
  });
}
exports.createLogistics = createLogistics;
function confirmOfflineOrder(id) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/order/offline?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'POST',
            data: {
              id: id
            }
          })];
        case 1:
          _a.sent();
          return [2 /*return*/];
      }
    });
  });
}

exports.confirmOfflineOrder = confirmOfflineOrder;
function editUserPrivateProfile(user_id, points) {
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4 /*yield*/, ApiUtil_1.req(Config_1.get().apiHost + "/user/points?token=" + Config_1.get().UserOutlet.getValue().token, {
            method: 'POST',
            data: {
              user_id: user_id,
              points: points
            }
          })];
        case 1:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
}
exports.editUserPrivateProfile = editUserPrivateProfile;
function createCustomOrder(payload) {
  return ApiUtil_1.req(Config_1.get().apiHost + "/payment/checkout/custom?token=" + Config_1.get().UserOutlet.getValue().token, {
    method: 'POST',
    data: {
      user_id: payload.user_id,
      name: payload.name,
      total: payload.total,
      description: payload.description,
      buyer_name: payload.buyer_name,
      buyer_email: payload.buyer_email,
      buyer_phone: payload.buyer_phone,
      payment_subtype: 'offline'
    }
  });
}
exports.createCustomOrder = createCustomOrder;
function updateProductStockAmount(_a) {
  var type = _a.type,
    product_id = _a.product_id,
    value = _a.value,
    data = _a.data;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().apiHost + "/stock", {
        method: 'POST',
        data: __assign({
          type: type,
          product_id: product_id,
          value: value
        }, data)
      })];
    });
  });
}
exports.updateProductStockAmount = updateProductStockAmount;
function sendReturnEmail(to, data) {
  var _a;
  return __awaiter(this, void 0, void 0, function () {
    return __generator(this, function (_b) {
      return [2 /*return*/, ApiUtil_1.req(Config_1.get().notificationHost + "/email/send/return?token=" + Config_1.get().UserOutlet.getValue().token, {
        method: 'POST',
        data: {
          to: to,
          data: {
            order_id: data.order_id,
            status: (_a = Cart.RETURN_STATUS_DISPLAY[data.status]) === null || _a === void 0 ? void 0 : _a.label,
            reason: data.data.reason,
            staff_note: data.data.staff_note || '',
            redirect_url: Config_1.get().webHost + "/profile/orders/?action=detail&order_id=" + data.order_id
          }
        }
      })];
    });
  });
}
exports.sendReturnEmail = sendReturnEmail;